document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const panel = event.target.closest('.mr-mobile-nav[open], .mr-search[open], .mr-nav-group[open]');
  if (panel) {
    panel.open = false;
    panel.querySelector('summary').focus();
  }
});
document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;
  document.querySelectorAll('.mr-search[open], .mr-mobile-nav[open], .mr-nav-group[open]').forEach((panel) => {
    if (!panel.contains(event.target)) panel.open = false;
  });
});

document.addEventListener('toggle', (event) => {
  const panel = event.target;
  if (!(panel instanceof HTMLDetailsElement) || !panel.open || !panel.matches('.mr-desktop-nav > .mr-nav-group')) return;
  document.querySelectorAll('.mr-desktop-nav > .mr-nav-group[open]').forEach((other) => { if (other !== panel) other.open = false; });
}, true);
const mrObserveHeader = () => {
  const header = document.querySelector('.mr-header--editorial');
  if (!header || header.dataset.mrObserved) return;
  header.dataset.mrObserved = 'true';
  const update = () => document.documentElement.style.setProperty('--mr-header-height', `${header.offsetHeight}px`);
  new ResizeObserver(update).observe(header);
  update();
};
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mrObserveHeader);
else mrObserveHeader();
document.addEventListener('shopify:section:load', mrObserveHeader);

document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;
  const trigger = event.target.closest('.mr-shop-look-button');
  if (trigger) {
    const dialog = document.getElementById(trigger.getAttribute('aria-controls'));
    if (dialog instanceof HTMLDialogElement && !dialog.open) dialog.showModal();
    return;
  }
  const close = event.target.closest('.mr-shop-look-close');
  if (close) close.closest('dialog').close();
  if (event.target.matches('dialog.mr-shop-look')) {
    const bounds = event.target.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) event.target.close();
  }
});
